import gql from 'graphql-tag';

export const InstanceIsInReverseTrialQuery = gql`
	query InstanceIsInReverseTrialQuery {
		signUpProperties {
			reverseTrial
		}
	}
`;
